/*
 * Hardway Performance — Cart Sync
 *
 * The processing-fee app (Magical Mandatory Fees) and the automatic
 * core / freight / tune charges all change the cart in the background.
 * Previously the fee app was set to reload the whole page after each of
 * those changes ("Force page refresh"), which wiped out whatever the
 * customer was filling in.
 *
 * With that setting off, this script does the job instead: after any
 * background cart change settles, it checks the real cart and, if the
 * totals moved, asks the theme to rebuild the cart drawer / cart page
 * (the theme's own `cart:build` event) — no page reload.
 *
 * The cart markup Shopify returns for a rebuild can lag a moment behind the
 * real cart (an older fee line, or none yet), so after each rebuild this
 * script compares the lines on the page with the real cart and rebuilds
 * again, a limited number of times, until they match.
 */
(function () {
  'use strict';
  if (window.__hwCartSync) return;
  window.__hwCartSync = true;

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var SETTLE_MS = 900;   // wait for the fee app to finish its own follow-up writes
  var VERIFY_MS = 1500;  // time for a rebuild to land before checking it
  var MAX_RETRIES = 4;   // extra rebuilds allowed when the markup comes back stale
  var timer = null;
  var lastSig = null;
  var checking = false;
  var again = false;
  var verifyTimer = null;

  function signature(cart) {
    return cart.item_count + ':' + cart.total_price + ':' + cart.items.map(function (i) {
      return i.key + 'x' + i.quantity + '@' + i.final_line_price;
    }).join(',');
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // True when every cart drawer / cart form on the page lists exactly the
  // line items the real cart has.
  function pageMatches(cart) {
    var want = cart.items.map(function (i) { return i.key; }).sort().join('|');
    var boxes = document.querySelectorAll('form[data-location] [data-products]');
    for (var b = 0; b < boxes.length; b++) {
      var have = Array.prototype.map.call(
        boxes[b].querySelectorAll('.cart__item[data-key]'),
        function (el) { return el.getAttribute('data-key'); }
      ).sort().join('|');
      if (have !== want) return false;
    }
    return true;
  }

  function rebuild(attempt) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    clearTimeout(verifyTimer);
    verifyTimer = setTimeout(function () {
      getCart()
        .then(function (cart) {
          if (signature(cart) !== lastSig) { schedule(); return; } // cart moved again
          if (!pageMatches(cart) && attempt < MAX_RETRIES) rebuild(attempt + 1);
        })
        .catch(function () { /* best effort */ });
    }, VERIFY_MS);
  }

  function check() {
    if (checking) { again = true; return; }
    checking = true;
    getCart()
      .then(function (cart) {
        var sig = signature(cart);
        if (lastSig === null) { lastSig = sig; return; } // first look — just remember it
        if (sig !== lastSig || !pageMatches(cart)) {
          lastSig = sig;
          rebuild(0);
        }
      })
      .catch(function () { /* best effort */ })
      .then(function () {
        checking = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, SETTLE_MS);
  }

  // The cart page has its own refresh logic — leave it alone.
  if (/\/cart\/?$/.test(window.location.pathname)) return;
  if (!('PerformanceObserver' in window)) return;
  try {
    new PerformanceObserver(function (list) {
      var hit = list.getEntries().some(function (e) {
        return (e.initiatorType === 'fetch' || e.initiatorType === 'xmlhttprequest') && CART_WRITE.test(e.name);
      });
      if (hit) schedule();
    }).observe({ entryTypes: ['resource'] });
  } catch (e) { return; /* not supported — the cart still rebuilds the next time it is opened */ }

  // Remember what the cart looks like when the page loads, so only real
  // changes trigger a rebuild.
  getCart().then(function (cart) { if (lastSig === null) lastSig = signature(cart); }).catch(function () {});
})();
